import Immutable from 'immutable';

import AuthenticationActions from 'sharedreact/actions/AuthenticationActions';
import NavigationActions from 'sharedreact/actions/NavigationActions';
import TablePreferencesActions from 'sharedreact/actions/TablePreferencesActions';
import WebAppsActions from 'sharedreact/actions/WebAppsActions';
import WebApp from 'sharedreact/data/WebApp';
import ServerEventListener from 'sharedreact/utils/ServerEventListener';

import ViewSessionListeners from 'workspaces/launcher/listeners/ViewSessionListeners';

let _serverEventConnectionLost = false;

function handleServerEventListenerOpened (event: Event | string): void {
  if (_serverEventConnectionLost) {
    _serverEventConnectionLost = false;
    AuthenticationActions.relogin(doPostLoginInit);
  }
}

let _isDebugEventsMode = false;
let _isLogHeartBeatsEnabled = false;

function handleServerEventListenerError (event: Event | string): void {
  console.log('ServerEventListener > errorHandler: %o', event);
  _serverEventConnectionLost = true;
}

function updateWebApps (data: any) {
  WebAppsActions.update(Immutable.List(data.data.map((item: any) => new WebApp(item))));
}

function setDebugEvents (logEvents: boolean, logHeartbeats: boolean): void {
  _isDebugEventsMode = logEvents;
  _isLogHeartBeatsEnabled = logHeartbeats;
}

function updateEvents (name: string, data: any): void {
  if (_isDebugEventsMode) {
    if (name !== 'heartbeat' || _isLogHeartBeatsEnabled) {
      console.log({name: name, data: data});
    }
  }
}

function doPostLoginInit (): void {
  ServerEventListener.init(
    handleServerEventListenerOpened,
    handleServerEventListenerError,
    'services/webappslauncher/events/'
  );

  ServerEventListener.start();

  ServerEventListener.addJSONListener(
    'webAppsChanged',
    updateWebApps
  );

  ServerEventListener.addJSONListener(
    'viewSessionsChanged',
    ViewSessionListeners.update
  );

  ServerEventListener.addAllEventsJSONListener(
    updateEvents
  );

  WebAppsActions.fetch();
  TablePreferencesActions.fetch();
}

function doPostLogoutCleanup () {
  NavigationActions.closeAllSlideOuts();

  // Close the event source connection.
  ServerEventListener.close();
}

const AuthenticationLauncherActions = {
  doPostLoginInit,
  doPostLogoutCleanup,
  setDebugEvents
};

export default AuthenticationLauncherActions;
